export enum CustomFormQueryTypes {
    ACTIVE_DRAFT = 0,
    ARCHIVED = 1,
    DELETED = 2
}